/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Notifications_Error_LoadingInputs */



/**
* | output |
* | --- |
* | "Error loading notification settings. Please close the options menu and try again." |
*
* @param {Options_Notifications_Error_LoadingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_notifications_error_loading = /** @type {((inputs?: Options_Notifications_Error_LoadingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Notifications_Error_LoadingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Erreur lors du chargement des paramètres de notifications. Veuillez fermer le menu des options et réessayer.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehler beim Laden der Benachrichtigungseinstellungen. Bitte schließen Sie das Optionsmenü und versuchen Sie es erneut.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Errore durante il caricamento delle impostazioni di notifica. Chiudi il menu delle opzioni e riprova.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ошибка загрузки настроек уведомлений. Пожалуйста, закройте меню параметров и попробуйте снова.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error al cargar la configuración de notificaciones. Cierre el menú de opciones y vuelva a intentarlo.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("加载通知设置时出错。请关闭选项菜单并重试。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("通知設定の読み込み中にエラーが発生しました。オプションメニューを閉じて、もう一度お試しください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सूचना सेटिंग लोड करने में त्रुटि। कृपया विकल्प मेनू बंद करें और पुनः प्रयास करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Erro ao carregar as configurações de notificação. Feche o menu de opções e tente novamente.")
	return /** @type {LocalizedString} */ ("Error loading notification settings. Please close the options menu and try again.")
});